import styled from 'styled-components';
import { color, font, query, space } from '@design/templateFns';

export const WrapperSocials = styled.div`
  margin-bottom: ${space('xl')};
  @media screen and (${query.below('desktop')}) {
    margin-bottom: ${space('lg')};
  }
`;

export const LinksWrapper = styled.div`
  a {
    ${font('subhead-sm')};
    color: ${color('gray4')};
    transition:
      border-color 0.2s ease-in-out,
      color 0.2s ease-in-out;

    @media screen and (${query.below('desktop')}) {
      ${font('subhead-xs')};
    }

    &:visited {
      color: ${color('gray4')};
    }

    &:hover {
      color: ${color('gray5')};
      border-color: ${color('gray5')};
    }

    & + a {
      margin-left: ${space('md')};
    }
  }
`;
